import type React from "react";
import type { IProjectGroupSearch } from "src/features/projectGroups/state/projectGroupsSlice";
import { Dropdown } from "../Input";
import type { IMediaSearch } from "src/features/gallery/state/gallerySlice";

export interface DropdownOption {
  value: string;
  optionText: string;
  isHidden?: boolean;
}

export interface ISortableDropdown {
  options: DropdownOption[];
  search: IMediaSearch | IProjectGroupSearch;
  handleChange: (arg: any) => any;
  disabled?: boolean;
}

const SortableDropdown: React.FC<ISortableDropdown> = ({
  options,
  search,
  handleChange,
  disabled,
}) => {
  const mustHidePlaceholder = Boolean(search.selectedId) || search.sort !== "0";
  const processedOptions = options.map((opt) =>
    opt.value === "0" ? { ...opt, isHidden: mustHidePlaceholder } : opt,
  );

  const handleDropdownChange = (value: string) => {
    handleChange({ target: { value } });
  };

  return (
    <Dropdown
      borderOff
      options={processedOptions}
      label=""
      value={search.sort}
      defaultValueIndex={0}
      asDefaultValue
      onChangeCb={handleDropdownChange}
      disabled={disabled}
    />
  );
};

export default SortableDropdown;
